"use client";

import type { CSSProperties } from "react";
import { useTheme } from "next-themes";

function SkeletonBar({
  className,
  style,
}: {
  className: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`rounded bg-contrast/6 shimmer shimmer-bg text-foreground ${className}`}
      style={style}
    />
  );
}

export function SpotlightSkeleton() {
  const { resolvedTheme } = useTheme();
  const isLight = resolvedTheme === "light";
  return (
    <div
      className="flex flex-col gap-2.5 items-start px-4 sm:px-8 py-4 sm:py-6 w-full border-b border-border"
      style={{
        backgroundImage: isLight
          ? "linear-gradient(180deg, rgba(124,58,237,0) 0%, rgba(124,58,237,0.04) 100%)"
          : "linear-gradient(180deg, rgba(154,106,237,0) 0%, rgba(154,106,237,0.06) 100%)",
      }}
    >
      <div className="flex items-center justify-between py-1.5 w-full">
        <SkeletonBar className="h-[18px] w-[180px]" />
        <SkeletonBar className="h-6 w-[92px] !rounded-md" />
      </div>
      <div className="flex flex-col gap-1.5 w-full">
        <SkeletonBar className="h-3.5 w-full" />
        <SkeletonBar className="h-3.5 w-full" />
        <SkeletonBar className="h-3.5 w-[60%]" />
      </div>
    </div>
  );
}
